export const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
export const urlRegExp =
  /((https?):\/\/)?(www.)?[a-z0-9-]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
export const zipCodeRegExp = /^\d{5}(?:[-\s]\d{4})?$/;
export const postalCodeRegExp = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

export function normalizeText(value: string | null): string | null {
  return value == null ? value : value.normalize('NFKC').trim();
}

export enum Country {
  Canada = 'Canada',
  USA = 'USA',
}

export enum RegionType {
  Province = 'Province',
  State = 'State',
}

export enum RegionCode {
  Canada = 'Postal code',
  USA = 'Zip code',
}

// [key in Countries]

export enum Provinces {
  'null' = '',
  Alberta = 'Alberta',
  'British Columbia' = 'British Columbia',
  Manitoba = 'Manitoba',
  'New Brunswick' = 'New Brunswick',
  'Newfoundland and Labrador' = 'Newfoundland and Labrador',
  'Nova Scotia' = 'Nova Scotia',
  Ontario = 'Ontario',
  'Prince Edward Island' = 'Prince Edward Island',
  Saskatchewan = 'Saskatchewan',
  Quebec = 'Quebec',
  'Northwest Territories' = 'Northwest Territories',
  Nunavut = 'Nunavut',
  Yukon = 'Yukon',
}

export enum States {
  'null' = '',
  Alabama = 'Alabama',
  Alaska = 'Alaska',
  Arizona = 'Arizona',
  Arkansas = 'Arkansas',
  California = 'California',
  Colorado = 'Colorado',
  Connecticut = 'Connecticut',
  Delaware = 'Delaware',
  DC = 'DC',
  Florida = 'Florida',
  Georgia = 'Georgia',
  Hawaii = 'Hawaii',
  Idaho = 'Idaho',
  Illinois = 'Illinois',
  Indiana = 'Indiana',
  Iowa = 'Iowa',
  Kansas = 'Kansas',
  Kentucky = 'Kentucky',
  Louisiana = 'Louisiana',
  Maine = 'Maine',
  Maryland = 'Maryland',
  Massachusetts = 'Massachusetts',
  Michigan = 'Michigan',
  Minnesota = 'Minnesota',
  Mississippi = 'Mississippi',
  Missouri = 'Missouri',
  Montana = 'Montana',
  Nebraska = 'Nebraska',
  Nevada = 'Nevada',
  'New Hampshire' = 'New Hampshire',
  'New Jersey' = 'New Jersey',
  'New Mexico' = 'New Mexico',
  'New York' = 'New York',
  'North Carolina' = 'North Carolina',
  'North Dakota' = 'North Dakota',
  Ohio = 'Ohio',
  Oklahoma = 'Oklahoma',
  Oregon = 'Oregon',
  Pennsylvania = 'Pennsylvania',
  'Rhode Island' = 'Rhode Island',
  'South Carolina' = 'South Carolina',
  'South Dakota' = 'South Dakota',
  Tennessee = 'Tennessee',
  Texas = 'Texas',
  Utah = 'Utah',
  Vermont = 'Vermont',
  'Virginia' = 'Virginia',
  'Washington' = 'Washington',
  'West Virginia' = 'West Virginia',
  Wisconsin = 'Wisconsin',
  Wyoming = 'Wyoming',
}
